export const ADMIN_TOKEN_KEY = "bp_admin_token";

export function getAdminToken(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.localStorage.getItem(ADMIN_TOKEN_KEY);
    const trimmed = String(value || "").trim();
    return trimmed || null;
  } catch {
    return null;
  }
}

export function setAdminToken(value: string): void {
  if (typeof window === "undefined") return;
  const trimmed = String(value || "").trim();
  try {
    if (!trimmed) {
      window.localStorage.removeItem(ADMIN_TOKEN_KEY);
    } else {
      window.localStorage.setItem(ADMIN_TOKEN_KEY, trimmed);
    }
  } catch {
    // localStorage unavailable (private browsing, storage quota exceeded)
  }
}

export function hasAdminToken(): boolean {
  return Boolean(getAdminToken());
}
